import React from 'react';
import { Eye } from 'lucide-react';

const RSVPFieldPreview = ({ fields }) => {
  const renderField = (field) => {
    const commonProps = {
      id: `preview-field-${field.id}`,
      placeholder: field.placeholder_text || '',
      required: field.is_required,
      disabled: true
    };

    switch (field.field_type) {
      case 'text':
      case 'email':
      case 'phone':
      case 'number':
        return (
          <input
            type={field.field_type === 'number' ? 'number' : 'text'}
            {...commonProps}
          />
        );

      case 'textarea':
        return (
          <textarea
            {...commonProps}
            rows="4"
          />
        );

      case 'select':
        return (
          <select {...commonProps}>
            <option value="">Select an option...</option>
            {field.options && field.options.map((option, idx) => (
              <option key={idx} value={option}>
                {option}
              </option>
            ))}
          </select>
        );

      case 'radio':
        return (
          <div className="radio-group">
            {field.options && field.options.map((option, idx) => (
              <label key={idx} className="radio-label">
                <input
                  type="radio"
                  name={`preview-field-${field.id}`}
                  value={option}
                  disabled
                />
                {option}
              </label>
            ))}
          </div>
        );

      case 'checkbox':
        return (
          <label className="checkbox-label">
            <input
              type="checkbox"
              disabled
            />
            Yes
          </label>
        );

      default:
        return <input type="text" {...commonProps} />;
    }
  };

  return (
    <div className="field-preview-container">
      <div className="preview-header">
        <Eye size={20} />
        <h3>Form Preview</h3>
        <span className="preview-badge">PREVIEW MODE</span>
      </div>

      <div className="preview-notice">
        <p>This is how your custom fields will appear to guests filling out the RSVP form.</p>
        <p><small>Form is disabled in preview mode.</small></p>
      </div>

      <div className="preview-form">
        <h4 className="preview-section-title">Custom Fields</h4>
        
        {fields.length === 0 ? (
          <div className="preview-empty">
            No custom fields to preview. Add fields to see them here.
          </div>
        ) : (
          <div className="preview-fields">
            {fields.map(field => (
              <div key={field.id} className="preview-field-group">
                <label className="preview-field-label">
                  {field.field_label}
                  {field.is_required && <span className="required-asterisk">*</span>}
                </label>
                {field.help_text && (
                  <small className="preview-help-text">{field.help_text}</small>
                )}
                {renderField(field)}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RSVPFieldPreview;
